import React from 'react'

function PropertySection() {
  return (
    <div>
        
        {/* <!-- Propertie Section Start --> */}
        <section class="propertie-feature-section parallaxie fix bg-cever"  style={{
    backgroundImage: "url('assets/img/home-1/propertie/propertie-feature-bg.jpg')",
  }}>
            <div class="container">
                <div class="propertie-feature-wrapper">
                    <div class="row g-4 align-items-center">
                        <div class="col-lg-6">
                            <div class="propertie-content">
                                <div class="section-title mb-0">
                                    <h5 class="wow fadeInUp"><i class="flaticon-home"></i> REAL ESTATE</h5>
                                    <h2 class="text-white wow fadeInUp" data-wow-delay=".3s">Your luxury. Your <br/> lifestyle.</h2>
                                </div>
                                <p class="propertie-text wow fadeInUp" data-wow-delay=".5s">
                                    At our core, we believe finding a home should feel comforting, not complicated. That’s why we offer trusted listings, expert support, 
                                </p>
                                {/* <a href="propertie.html" class="theme-btn wow fadeInUp" data-wow-delay=".7s">
                                    View Properties <i class="flaticon-home"></i> 
                                </a> */}
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="propertie-image">
                                {/* <img src="assets/img/home-1/propertie/propertie-feature-image.jpg" alt="img" class="wow img-custom-anim-right"/> */}
                                <img src="/img/map.jpg" alt="img" class="wow img-custom-anim-right" style={{maxHeight:'554px' , width:'100%',maxWidth:'1005px'    }}/>
    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
  )
}

export default PropertySection